const templateUrl = require('./spinner.html');

function ogSpinner() {
  return {
    templateUrl: templateUrl,
    restrict: 'AE',
    bindToController: {
      size: '@ogSize' // [1|2|3|4|5]
    },
    controllerAs: '$ctrl',
    controller: function() {}
  };
}

ogSpinner.$inject = [];

module.exports = ogSpinner;
